let mobileElements = {
  mobileMenu: document.querySelector('.mobile-menu'),
  mobileMenuTrigger: document.querySelector('.header__mobile-link'),
  body: document.querySelector('body'),
  header: document.querySelector('.header'),
  items: document.querySelectorAll('.menu__item'),
  socials: document.querySelector('.mobile-menu__socials'),
  button: document.querySelector('.mobile-menu__button'),
}

let { mobileMenuTrigger, mobileMenu, body, header, items, socials, button } = mobileElements;

const animateItems = () => {

  let interval = 50;
  let total_timeouts = 0;

  items.forEach((i, index) => {
    i.addEventListener('click' , () => {
      toggleChildren(i);
    });
    if (!i.classList.contains('reveal')) {

      total_timeouts = index;

      setTimeout(function () {

        i.classList.toggle('reveal');
      }, total_timeouts * interval);
    } else {
      i.classList.toggle('reveal');
    }
  });

  total_timeouts += 1;

  setTimeout(function () {
    socials.classList.toggle('reveal');
  }, total_timeouts * interval );

  total_timeouts += 1;

  setTimeout(function () {
    button.classList.toggle('reveal');
  }, total_timeouts * interval );

}

function toggleMenu() {

  mobileMenu.classList.toggle('mobile-menu--active');
  mobileMenuTrigger.classList.toggle('header__mobile-link--opened');
  body.classList.toggle('stopScroll');
  header.classList.toggle('header--menuOpen');

  animateItems();

}

function toggleChildren(item) {
  item.classList.toggle('menu__item--parent-active');
  item.next('.footer__accordion').classList.toggle('footer__accordion--active');
}

function MobileMenu () {

  mobileMenuTrigger.addEventListener('click', () => toggleMenu());

}

export default MobileMenu;